import React, { Component } from 'react'
import { useNavigate } from "react-router-dom";

const styles = `
  .notice-wrapper {
    min-height: 100vh;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 48px 24px;
  }

  .notice-card {
    background: #fffdf8;
    border: 1px solid #d4c9b0;
    max-width: 900px;
    width: 100%;
    padding: 0;
    box-shadow: 0 4px 32px rgba(80, 60, 20, 0.10), 0 1px 0 #bfae8e;
    position: relative;
    animation: fadeInUp 0.7s cubic-bezier(.22,.68,0,1.2) both;
  }

  @keyframes fadeInUp {
    from { opacity: 0; transform: translateY(28px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .notice-band {
    background: #1a1209;
    height: 8px;
    width: 100%;
  }

  .notice-inner {
    padding: 50px;
  }

  .notice-stamp {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 32px;
  }

  .notice-stamp-icon {
    width: 38px;
    height: 38px;
    background: #b8222a;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .notice-stamp-icon svg {
    width: 20px;
    height: 20px;
    fill: #fff;
  }

  .notice-stamp-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    color: #b8222a;
    line-height: 1.2;
  }

  .notice-stamp-sub {
    font-size: 10px;
    letter-spacing: 0.18em;
    color: #a09070;
    font-style: italic;
    margin-top: 2px;
  }

  .notice-divider {
    border: none;
    border-top: 1.5px solid #e0d5be;
    margin: 0 0 32px;
  }

  .notice-title {
    font-size: 2rem;
    font-weight: 900;
    color: #1a1209;
    line-height: 1.15;
    margin: 0 0 8px;
    letter-spacing: -0.01em;
  }

  .notice-subtitle {
    font-size: 13px;
    color: #a09070;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    font-style: italic;
    margin-bottom: 32px;
  }

  .notice-body p {
    font-size: 1.05rem;
    line-height: 1.85;
    color: #3d2f1a;
    margin: 0 0 20px;
    font-weight: 300;
  }

  .notice-body strong {
    font-weight: 700;
    color: #1a1209;
  }

  .notice-list {
    margin: 0 0 24px 20px;
    padding: 0;
    list-style-type: disc;
  }

  .notice-list li {
    font-size: 1rem;
    line-height: 1.7;
    color: #3d2f1a;
    margin-bottom: 10px;
    font-weight: 300;
  }

  .notice-footer {
    margin-top: 40px;
    padding-top: 24px;
    border-top: 1px solid #e0d5be;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
  }

  .notice-issued {
    font-size: 12px;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #a09070;
  }

  @media (max-width: 600px) {
    .notice-inner {
      padding: 32px 24px 36px;
    }
    .notice-title {
      font-size: 1.5rem;
    }
    .notice-body p, .notice-list li {
      font-size: 0.97rem;
    }
  }
`;

class PublicNotice extends Component {
  render() {
    return (
      <>
        <style>{styles}</style>
        <div className="notice-wrapper">
          <div className="notice-card">
            <div className="notice-band" />
            <div className="notice-inner">
              
              <div className="notice-stamp">
                <div className="notice-stamp-icon">
                  <svg viewBox="0 0 24 24">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                  </svg>
                </div>
                <div>
                  <div className="notice-stamp-label">Press Release</div>
                  <div className="notice-stamp-sub">Dubai, UAE</div>
                  <div className="notice-stamp-sub">Dated : 30 May 2026</div>
                </div>
              </div>

              <hr className="notice-divider" />

              <h2 className="notice-title">
                Alhind Group Clarifies Misreported<br />
                Information Regarding CPV Services in the UAE
              </h2>
              <p className="notice-subtitle">Official Clarification Statement</p>

              <div className="notice-body">
                <p>
                  Alhind Group wishes to place on record a formal clarification regarding certain statements recently published in media reports concerning the rollout and operation of Consular, Passport, and Visa (CPV) services in the UAE.
                </p>
                <p>
                  It has come to our attention that several comments, quotations, operational details, service commitments, and future plans have been attributed to Alhind representatives. These statements were neither officially issued, authorized, approved, nor communicated by Alhind Group through any recognized corporate communication channel.
                </p>
                
                <p>
                  The published article contains references to, among other things:
                </p>

                <ul className="notice-list">
                  <li>Claims that applicants will be able to easily secure appointments and that specific appointment policies have already been finalized.</li>
                  <li>Assertions that parents seeking passports for newborn children can avail services without appointments.</li>
                  <li>Statements regarding dedicated service counters exclusively for Emirati nationals applying for Indian visas.</li>
                  <li>Claims that such counters will be staffed by Arabic-speaking personnel and supported by dedicated coordinators.</li>
                  <li>References to Alhind testing new technology for passport renewal services and plans for imminent public rollout.</li>
                  <li>Statements suggesting that pilot technology initiatives are currently underway and producing promising results.</li>
                  <li>Claims that more than 400 additional employees have already been hired specifically for CPV operations.</li>
                  <li>References to future service pricing, passport renewal costs, and commitments relating to affordability of services.</li>
                </ul>

                <p>
                  Alhind Group categorically clarifies that the above statements are inaccurate and do not represent the official position of the company.
                </p>
                <p>
                  At no point has Alhind Group publicly announced, confirmed, or authorized any of the aforementioned operational details, service commitments, staffing numbers, technology deployments, pricing structures, appointment policies, or future rollout plans.
                </p>
                <p>
                  Furthermore, any quotations attributed to Alhind representatives in relation to these matters should not be considered authentic unless they have been officially released through authorized corporate communication channels.
                </p>
                
                <p>
                  As a responsible service provider, Alhind Group will communicate all verified information, service procedures, operational announcements, eligibility criteria, pricing structures, appointment mechanisms, and public advisories only through:
                </p>

                <ul className="notice-list">
                  <li>Official Alhind Group communication channels;</li>
                  <li>Authorized press releases;</li>
                  <li>Official social media handles;</li>
                  <li>Corporate website announcements;</li>
                  <li>Written communications approved by the competent authorities.</li>
                </ul>

                <p>
                  We further wish to unequivocally clarify that all applicants must physically visit the designated service centers for availing Consular, Passport, and Visa services. No home-service model, doorstep enrollment facility, home biometric collection, or off-site application processing has been approved or announced by Alhind Group. Any suggestion to the contrary is incorrect and does not reflect the approved service delivery framework. The public is advised not to rely on such claims and to seek information only through official and verified channels.
                </p>

                <h2 className="notice-title" style={{ fontSize: '1.5rem', marginTop: '40px', marginBottom: '12px' }}>
                  Advisory to Media and the Public
                </h2>
                
                <p>
                  We respectfully urge media organizations, stakeholders, and members of the public to exercise caution and rely solely on officially verified communications.
                </p>
                <p>
                  The publication or circulation of unverified information regarding government-related services has the potential to create confusion among applicants, generate unrealistic expectations, and adversely impact the orderly rollout of essential public services.
                </p>
                <p>
                  Alhind Group therefore requests all media outlets and stakeholders to refrain from reproducing or circulating unverified claims and to seek confirmation through official channels before publishing information relating to CPV services.
                </p>
                <p>
                  We remain committed to transparency, accuracy, operational excellence, and the highest standards of public service in support of the Embassy of India and the Indian community in the UAE.
                </p>
              </div>

              <div className="notice-footer">
                <div>
                  <span className="notice-issued" style={{ display: 'block', fontWeight: 700, color: '#1a1209', fontStyle: 'normal' }}>Issued by:</span>
                  <span className="notice-issued" style={{ display: 'block', fontStyle: 'normal', color: '#1a1209' }}>Alhind Group</span>
                  <span className="notice-issued" style={{ display: 'block' }}>Corporate Communications Department</span>
                </div>
                <span className="notice-issued" style={{ fontWeight: 700 }}>Official Clarification Statement</span>
              </div>

            </div>
          </div>
        </div>
      </>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <PublicNotice {...props} navigate={navigate} />;
}

export default WithNavigate;